var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.mobile
    ? _c(
        "v-card-title",
        { class: "question-green-bgr p-3" },
        [
          _c(
            "v-container",
            {
              staticClass: "p-2",
              attrs: {
                fluid: "",
                "grid-list-lg": "",
                "fill-height": "",
                "text-xs-center": "",
              },
            },
            [
              _c(
                "v-layout",
                {
                  staticClass: "result-question p-0",
                  attrs: { row: "", wrap: "", "align-center": "" },
                },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-sm-start",
                      attrs: { xs7: "", md8: "" },
                    },
                    [
                      _c("div", { staticClass: "title flex-nowrap" }, [
                        _vm._v(_vm._s(_vm.skill.name)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "caption" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.skill.skillItems.length) +
                            "\n          " +
                            _vm._s(
                              _vm.$t("exam_result.skill_items", {
                                format: _vm.LETTER_FORMAT.UPTITLECASE,
                              })
                            ) +
                            ", " +
                            _vm._s(_vm.skillAverage) +
                            "%\n          " +
                            _vm._s(
                              _vm.$t("exam_result.average_point", {
                                format: _vm.LETTER_FORMAT.UPTITLECASE,
                              })
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-center",
                      attrs: { xs5: "", md4: "" },
                    },
                    [
                      _c("ChartProgress", {
                        attrs: {
                          size: 160,
                          series: [_vm.skillScore],
                          labelColor: "#666666",
                          label: _vm.skillScore.toString(),
                          subLabel: "%",
                          chartColor:
                            _vm.skillScore >= _vm.skillAverage
                              ? "#2699fb"
                              : "#f44337",
                          trackColor: "#ffffff",
                          fontSizeLabel: "13px",
                          fontSizeValue: "24px",
                          labelOffsetY: 5,
                          subLabelOffsetY: 5,
                          trackOpacity: 1,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c("v-layout", { staticClass: "question-green-bgr p-3" }, [
        _c("table", { staticClass: "skill-full-width" }, [
          _c("tr", [
            _c("td", { staticClass: "skill-td-left" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.skill.name)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "caption" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.skill.skillItems.length) +
                    "\n          " +
                    _vm._s(
                      _vm.$t("exam_result.skill_items", {
                        format: _vm.LETTER_FORMAT.UPTITLECASE,
                      })
                    ) +
                    ", " +
                    _vm._s(_vm.skillAverage) +
                    "%\n          " +
                    _vm._s(
                      _vm.$t("exam_result.average_point", {
                        format: _vm.LETTER_FORMAT.UPTITLECASE,
                      })
                    ) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "text-xs-right skill-td-right" },
              [
                _c("ChartProgress", {
                  attrs: {
                    size: 160,
                    series: [_vm.skillScore],
                    labelColor: "#666666",
                    label: _vm.skillScore.toString(),
                    subLabel: "%",
                    chartColor:
                      _vm.skillScore >= _vm.skillAverage
                        ? "#2699fb"
                        : "#f44337",
                    trackColor: "#ffffff",
                    fontSizeLabel: "13px",
                    fontSizeValue: "24px",
                    labelOffsetY: 5,
                    subLabelOffsetY: 5,
                    trackOpacity: 1,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }